import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ForeignLanguangeDTO  {
    _originalTypeClassName = "zSHR.BO.ForeignLanguangeDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ForeignLanguangeDTO.translate = translateService;
}
this.Id = null;
this.DiplomaTitle = null;
this.ObtainingDate = null;
this.ExpiredDate = null;
this.DiplomaLink = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.Diploma = null;
this.CERFInt = null;
this.CEFRLevel = null;
this.ForeignLanguangeDTOKey = null;
this._key = this.ForeignLanguangeDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DiplomaTitle:any;
ObtainingDate:any;
ExpiredDate:any;
DiplomaLink:any;
DocumentType:any;
DocumentDescription:any;
Diploma:any;
CERFInt:any;
CEFRLevel:any;
InstDtO:any;
LangDTO:any;
private _ForeignLanguangeDTOKey:any;
get ForeignLanguangeDTOKey(): any {
    return this._ForeignLanguangeDTOKey;
  }
set ForeignLanguangeDTOKey(value: any) {
    this._ForeignLanguangeDTOKey = value;
    this._key = value;
  }
static setInstDtO = ($this, value) => {
var oldValue = $this.InstDtO;
$this.InstDtO = value;
if (value != null) {
}
}
static setLangDTO = ($this, value) => {
var oldValue = $this.LangDTO;
$this.LangDTO = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ForeignLanguangeDTOKey == null || $this.ForeignLanguangeDTOKey == 0;
            }


}